import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { Location } from '@angular/common';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { filter } from 'rxjs/operators';
import { APP_ROUTES as ROUTES } from './app.routes';
import { AppFacade } from './facades/app.facade';
import { UIService } from './services/ui.service';
import { UtilService } from './services/util.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  public navigation$: Subscription;
  public activeRoutes$: Subscription;

  constructor(
    private _appFacade: AppFacade,
    private _utilService: UtilService,
    private _activeRoute: ActivatedRoute,
    private _uiService: UIService,
    private _location: Location,
    private _router: Router
  ) {
    this._router.events.subscribe((event: NavigationStart) => {
      if (event.navigationTrigger === 'popstate') {
        const currentRoute = this._router.routerState;
        this._router.navigateByUrl(currentRoute.snapshot.url, {
          skipLocationChange: true,
        });
      }
    });
  }

  ngOnInit() {
    this.navigation$ = this._appFacade
      .getUrlByChangeEvent()
      .subscribe((navigation: NavigationEnd) => {
        const { url } = navigation;
        const urlWithoutParams: Array<string> = url?.split('?');
        this._appFacade.getCurrentRoute(urlWithoutParams[0]);
        this._hideSplashAndScrollTo();
      });
    this._handleUrlParams();
  }

  ngOnDestroy(): void {
    this.navigation$?.unsubscribe();
    this.activeRoutes$?.unsubscribe();
  }

  private _hideSplashAndScrollTo(): void {
    this._utilService.hideSplash();
    window.scrollTo(0, 0);
  }

  private _handleUrlParams() {
    this.activeRoutes$ = this._activeRoute.queryParams
      .pipe(filter((param) => !!param.error))
      .subscribe((_) => this._showErrorMessage());
  }

  private _showErrorMessage() {
    const message: string = CONST.MESSAGES.TRANSACTION_TOKEN_UNEXIST;
    this._uiService.showSnackbar(message);
    this._location.replaceState(ROUTES.AUTH);
  }
}
